/* HOME PASSION · "Setle kazan" karti — iki urunu birlikte sepete ekler

   OLU INDIRIM KODU YONLENDIRMESI KALDIRILDI
   -----------------------------------------
   Eskiden ekleme sonrasi /discount/SET10?redirect=/cart adresine
   gidiliyordu. Magazada SET10 / SET15 / SET20 diye bir indirim kodu YOK;
   yonlendirme sepete calismayan bir kod yapistiriyordu.

   Set indirimleri OTOMATIK calisiyor (2 parca %10, 3 parca %15,
   4 parca %20 — kapsam: "Tum Dekoratif Yastiklar"). Kart hem kilifi hem
   ic yastigi ekliyor, ikisi de bu koleksiyonda; indirim sepette kendiliginden
   dusuyor. Artik yonlendirme yerine acilir sepet aciliyor.

   DUZELTME — 422 YANITI YUTULUYORDU
   ---------------------------------
   Eski surum r.ok'i kontrol etmiyordu: stok yetmediginde Shopify 422
   donup HICBIR SEYI eklemiyor, kart yine de acilir sepeti acip basarili
   gorunuyordu. Artik hata varsa Shopify'in kendi mesaji kartin altinda
   ([data-setwarn]) gosteriliyor. */
(function(){
  'use strict';
  function warnEl(b){
    var box = b.closest('.hp-set');
    return box ? box.querySelector('[data-setwarn]') : null;
  }
  function init(root){
    (root||document).querySelectorAll('[data-setadd]:not([data-i])').forEach(function(b){
      b.dataset.i='1';
      b.addEventListener('click', function(){
        if(b.disabled) return;
        var w=warnEl(b);
        if(w){ w.hidden=true; w.textContent=''; }
        var old=b.innerHTML; b.disabled=true; b.textContent='Ekleniyor';
        var items=[{id:parseInt(b.dataset.a,10),quantity:1},{id:parseInt(b.dataset.b,10),quantity:1}];
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, data:j}; }); })
          .then(function(res){
            b.innerHTML=old; b.disabled=false;
            if(!res.ok){
              /* 422 — hicbiri eklenmedi. Sahte basari gosterme. */
              if(w){
                w.hidden=false;
                w.textContent=(res.data && (res.data.description||res.data.message)) || 'Set şu an eklenemedi.';
              }
              return;
            }
            document.dispatchEvent(new CustomEvent('hp:cart-added'));
          })
          .catch(function(){
            b.innerHTML=old; b.disabled=false;
            if(w){ w.hidden=false; w.textContent='Bağlantı hatası, tekrar deneyin.'; }
          });
      });
    });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){init()}); }
  else { init(); }
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
